import React, { useEffect, useState } from 'react'
import { Box, Container, IconButton, Theme, Grid, Collapse } from '@mui/material'
import { makeStyles } from '@mui/styles'
import Slider, { Settings } from 'react-slick'
import HtmlReactParser from 'html-react-parser'
import Moment from 'react-moment'
import { img as imgs } from '../../../imgs'
import { Modal } from '../../../components'
import { getNews } from '../../../api'
import { str } from '../../../utils'

const NextArrow = (props: any) => {
  const classes = useStyles()
  const { className, style, onClick } = props
  return (
    <Box className={className} style={{ ...style }}>
      <IconButton color="primary" onClick={onClick} className={classes.btn}>
        <img src={imgs.next} alt="" height="100%" />
      </IconButton>
    </Box>
  )
}

const PrevArrow = (props: any) => {
  const classes = useStyles()
  const { className, style, onClick } = props
  return (
    <Box className={className} style={{ ...style }}>
      <IconButton color="primary" onClick={onClick} className={classes.btn}>
        <img src={imgs.prev} alt="" height="100%" />
      </IconButton>
    </Box>
  )
}

const Slide: React.FC<{ img: string; title: string; start_datetime: string; anons: string; body: string }> = ({
  img,
  title,
  anons,
  body,
  start_datetime,
}): JSX.Element => {
  const classes = useStyles()

  const { REACT_APP_URL: URL } = process.env

  const [show, setShow] = useState<boolean>(false)

  return (
    <Box>
      <NewsTopicModal show={show} img={img} title={title} body={body} onClose={() => setShow(false)} />

      <Box className={classes.slide}>
        <img
          src={`${URL === 'http://localhost:3000' ? 'https://irbcup.xtest.atoms.ru' : URL}${img}`}
          alt=""
          className={classes.imgSlide}
        />
        <Grid container direction="column" justifyContent="space-evenly" className={classes.grid}>
          <Grid item xs={12}>
            <Box className={classes.titleSlide}>{title}</Box>
          </Grid>
          <Grid item xs={12}>
            <Box className={classes.dateSlide}>
              <Moment format="DD.MM.YYYY г.">{start_datetime}</Moment>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box className={classes.textSlide}>{str.normalize(anons)}</Box>
          </Grid>
          <Grid item xs={12}>
            {body && (
              <Box className={classes.furtherSlide}>
                <Box className={classes.link} onClick={() => setShow(true)}>
                  Читать далее &gt;&gt;
                </Box>
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export const NewsTopicModal: React.FC<{
  show: boolean
  img: string
  title: string
  body: string
  onClose: () => void
}> = ({ show = false, img, title, body = '', onClose = () => {} }): JSX.Element => {
  const classes = useStyles()

  const { REACT_APP_URL: URL } = process.env

  const [collapse, setCollapse] = useState<boolean>(true)

  const onCloseModal = () => {
    onClose()
    setCollapse(false)
  }

  useEffect(() => {
    if (!collapse) {
      setTimeout(() => setCollapse(true), 200)
    }
  }, [collapse])

  return (
    <Modal open={show} maxWidth="md" title="Новость" onClose={onCloseModal}>
      <Collapse in={collapse}>
        <Box mt={3} className={classes.newsBox}>
          <Grid container justifyContent="center">
            <Grid item>
              <img
                src={`${URL === 'http://localhost:3000' ? 'https://irbcup.xtest.atoms.ru' : URL}${img}`}
                alt=""
                className={classes.imgModal}
              />
            </Grid>
          </Grid>
          <Box className={classes.titleModal}>{title}</Box>
          <Box className={classes.textModal}>{body && HtmlReactParser(body.replace(/[\r\n]+/g, '<br/>'))}</Box>
        </Box>
      </Collapse>
    </Modal>
  )
}

export const NewsSection: React.FC = (): JSX.Element => {
  const classes = useStyles()

  const [slider, setSlider] = useState<any>([])

  const settings: Settings = {
    dots: false,
    speed: 300,
    infinite: false,
    slidesToShow: 3,
    initialSlide: 0,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    afterChange: (index: number) => {},
    beforeChange: (current: number, next: number) => {},
    responsive: [
      { breakpoint: 960, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  }

  useEffect(() => {
    getNews().then((res) => {
      setSlider(res.data.news)
    })
  }, [])

  return (
    <Box className={classes.page}>
      <Container className={classes.container}>
        <Box width="100%" textAlign="center" className={classes.title}>
          Новости
        </Box>
        {slider.length > 0 ? (
          <Box className={classes.boxSlider}>
            <Slider {...settings}>
              {slider.map((item: any) => (
                <Slide {...item} />
              ))}
            </Slider>
          </Box>
        ) : (
          <Grid container justifyContent="center" alignItems="center" height={250}>
            <Grid item>
              <Box fontSize={{ xs: 14, sm: 17, md: 20 }}>Новостей Кубка пока нет</Box>
            </Grid>
          </Grid>
        )}
      </Container>
      <img src={imgs.newsBottom} alt="" className={classes.newsBottom} />
    </Box>
  )
}

const useStyles = makeStyles(({ breakpoints: { down }, palette }: Theme) => ({
  page: {
    width: '100%',
    padding: '100px 0 10px',
    overflow: 'hidden',
    [down('lg')]: {
      padding: '80px 0 10px',
    },
    [down('sm')]: {
      padding: '50px 0 10px',
    },
  },
  container: {
    maxWidth: '1300px!important',
  },
  title: {
    fontSize: 44,
    fontWeight: 700,
    marginBottom: 50,
    textTransform: 'uppercase',
    [down('lg')]: {
      fontSize: 40,
      marginBottom: 40,
    },
    [down('sm')]: {
      fontSize: 28,
      marginBottom: 30,
    },
  },
  boxSlider: {
    width: '100%',
    '& .slick-list': {
      width: '90%',
      position: 'relative',
      left: '5%',
    },
    '& .slick-slide': {},
    '& .slick-track': {
      margin: '0 auto',
    },
    '& .slick-next:before, .slick-prev:before': {
      content: 'none',
      width: '80px!important',
      height: '80px!important',
      [down('md')]: {
        width: '70px!important',
        height: '70px!important',
      },
    },
    '& .slick-next, .slick-prev': {
      top: '25%',
      width: '80px!important',
      height: '80px!important',
      [down('lg')]: {
        top: '20%',
      },
      [down('md')]: {
        top: '22%',
        width: '70px!important',
        height: '70px!important',
      },
    },
  },
  btn: {
    width: 80,
    height: 80,
    [down('md')]: {
      width: 70,
      height: 70,
    },
  },
  slide: {
    borderRadius: 14,
    margin: '0 auto',
    width: 280,
    height: 620,
    [down('lg')]: {
      width: 250,
      height: 620,
    },
    [down('sm')]: {
      width: 230,
      height: 540,
    },
  },
  imgSlide: {
    width: '100%',
    maxHeight: 185,
  },
  titleSlide: {
    marginTop: 50,
    fontSize: 22,
    fontWeight: 700,
    textTransform: 'uppercase',
    [down('lg')]: {
      marginTop: 40,
      fontSize: 23,
    },
    [down('sm')]: {
      marginTop: 30,
      fontSize: 21,
    },
  },
  dateSlide: {
    fontSize: 15,
    fontWeight: 500,
    marginTop: 10,
    color: '#6C6C6C',
    [down('md')]: {
      fontSize: 14,
    },
    [down('sm')]: {
      fontSize: 13,
    },
  },
  textSlide: {
    margin: '25px 0 15px',
    fontSize: 17,
    fontWeight: 500,
    '& a': {
      color: palette.text.secondary,
    },
    [down('lg')]: {
      fontSize: 14,
    },
    [down('sm')]: {
      margin: '20px 0 12px',
      fontSize: 13,
    },
  },
  furtherSlide: {
    '-webkit-tap-highlight-color': 'transparent',
    color: palette.primary.contrastText,
    float: 'right',
  },
  link: {
    fontSize: 14,
    float: 'right',
    fontWeight: 600,
    transition: '0.3s',
    textDecoration: 'none!important',
    '-webkit-tap-highlight-color': 'transparent',
    color: `${palette.primary.contrastText}!important`,
    '&:hover': {
      color: 'rgb(255, 255, 255, 0.6)!important',
    },
    [down('lg')]: {
      margin: '15px 0',
      fontSize: 12,
    },
    [down('sm')]: {
      margin: '15px 0',
      fontSize: 11,
    },
  },
  grid: {
    minHeight: 270,
    [down('sm')]: {
      minHeight: 200,
    },
  },
  newsBottom: {
    width: '100%',
    minWidth: 1100,
    marginTop: 50,
    [down('lg')]: {
      marginTop: 20,
    },
    [down('sm')]: {
      marginTop: 0,
    },
  },
  newsBox: {
    width: '100%',
  },
  imgModal: {
    width: 'auto',
    maxHeight: 185,
    [down('sm')]: {
      maxHeight: 150,
    },
  },
  titleModal: {
    fontSize: 20,
    fontWeight: 700,
    textAlign: 'center',
    paddingLeft: 20,
    paddingRight: 20,
    lineHeight: 1.4,
    textTransform: 'uppercase',
    margin: '20px 0',
    [down('sm')]: {
      fontSize: 18,
      paddingLeft: 10,
      paddingRight: 10,
      margin: '15px 0',
    },
  },
  textModal: {
    fontSize: 15,
    fontWeight: 500,
    textAlign: 'left',
    paddingLeft: 20,
    paddingRight: 20,
    lineHeight: 1.4,
    [down('sm')]: {
      fontSize: 14,
      paddingLeft: 10,
      paddingRight: 10,
    },
  },
}))
